module.exports = __webpack_public_path__ + "static/img/jp7.f2713413.png";